export class CST {
    public cst =
        [
            { nome: 'ICMS_000', codigo: '00', descricao: 'Tributada integralmente' , codJkaw:'1', simples:false},
            { nome: 'ICMS_010', codigo: '10', descricao: 'Tributada e com cobrança do ICMS por substituição tributária' , codJkaw:'2', simples:false},
            { nome: 'ICMS_020', codigo: '20', descricao: 'Com redução de base de cálculo' , codJkaw:'3', simples:false},
            { nome: 'ICMS_030', codigo: '30', descricao: 'Isenta ou nao tributada e com cobrança do ICMS por substituição tributária' , codJkaw:'4', simples:false},
            { nome: 'ICMS_040', codigo: '40', descricao: 'Isenta' , codJkaw:'5', simples:false},
            { nome: 'ICMS_041', codigo: '41', descricao: 'Nao tributada' , codJkaw:'6', simples:false},
            { nome: 'ICMS_050', codigo: '50', descricao: 'Suspensão' , codJkaw:'7', simples:false},
            { nome: 'ICMS_051', codigo: '51', descricao: 'Diferimento' , codJkaw:'8', simples:false},
            { nome: 'ICMS_060', codigo: '60', descricao: 'ICMS cobrado anteriormente por substituição tributária' , codJkaw:'9', simples:false},
            { nome: 'ICMS_070', codigo: '70', descricao: 'Com redução de base de cálculo e cobrança do ICMS por substituição tributária' , codJkaw:'A', simples:false},
            { nome: 'ICMS_090', codigo: '90', descricao: 'Outros' , codJkaw:'B', simples:false},
            { nome: 'CSOSN_101', codigo: '101', descricao: 'Com permissão de crédito' , codJkaw:'C', simples:true},
            { nome: 'CSOSN_102', codigo: '102', descricao: 'Sem permissão de crédito' , codJkaw:'D', simples:true},
            { nome: 'CSOSN_103', codigo: '103', descricao: 'Isenção p/ faixa de receita bruta' , codJkaw:'E', simples:true},
            { nome: 'CSOSN_201', codigo: '201', descricao: 'Com permissão de crédito e com cobrança por ST' , codJkaw:'F', simples:true},
            { nome: 'CSOSN_202', codigo: '202', descricao: 'Sem permissão de crédito e com cobrança por ST' , codJkaw:'G', simples:true},
            { nome: 'CSOSN_203', codigo: '203', descricao: 'Isenção para faixa receita bruta com cobrança por ST' , codJkaw:'H', simples:true},
            { nome: 'CSOSN_300', codigo: '300', descricao: 'Imune' , codJkaw:'I', simples:true},
            { nome: 'CSOSN_400', codigo: '400', descricao: 'Nao tributada' , codJkaw:'J', simples:true},
            { nome: 'CSOSN_500', codigo: '500', descricao: 'ICMS cob anteriormente p/ST ou antecipação' , codJkaw:'K', simples:true},
            { nome: 'CSOSN_900', codigo: '900', descricao: 'Outros', codJkaw:'L', simples:true }
        ];

   getByCodigo(codigo: string){
        return this.cst.find(s=>s.codigo===codigo);
   }
   
   getByCodJkaw(codJkaw: string){
    return this.cst.find(s=>s.codJkaw===codJkaw);
    }    

}






















